module.exports = __webpack_public_path__ + "static/media/Jessica.ae00cbd6.jpeg";